var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.initialLetter)?_c('span',{staticClass:"tile d-inline-block text-center"},[_vm._v(" "+_vm._s(_vm.initialLetter.toUpperCase())+" ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }